import { render } from "./XiangQing.vue?vue&type=template&id=1ef60cb2&scoped=true"
import script from "./XiangQing.vue?vue&type=script&lang=js"
export * from "./XiangQing.vue?vue&type=script&lang=js"

import "./XiangQing.vue?vue&type=style&index=0&id=1ef60cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef60cb2"]])

export default __exports__